<template lang="pug">
  label(
    :for="id"
    v-click-outside="onBlur"
  )
    textarea(
      :id="id"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      @focus="onFocus"
      @focusout="onFocusout"
      :placeholder="placeholder"
      :maxlength="maxlength"
      ref="textarea"
      :rows="rows"
    )
    slot
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import { vOnClickOutside } from '@vueuse/components';

  export default defineNuxtComponent({
    name: 'TextAreaCustom',

    directives: {
      clickOutside: vOnClickOutside,
    },

    props: {
      id: {
        type: String as PropType<string>,
        required: true,
      },
      modelValue: {
        type: String as PropType<string>,
        required: true,
      },
      placeholder: {
        type: String as PropType<string>,
        default: '',
      },
      maxlength: {
        type: Number as PropType<number>,
        default: -1,
      },
      rows: {
        type: Number as PropType<number>,
        default: 1,
      },
    },

    data: () => ({
      startHeight: 0,
    }),

    watch: {
      modelValue() {
        this.resizeTextarea();
      },
      rows() {
        this.resizeTextarea();
      },
    },

    mounted() {
      this.resizeTextarea();
    },

    methods: {
      async resizeTextarea(): Promise<void> {
        await this.$nextTick();
        const textarea = this.$refs.textarea as HTMLElement;
        this.startHeight = !this.startHeight
          ? parseInt(textarea.style.height, 10)
          : this.startHeight;
        textarea.style.height = 'auto';
        textarea.style.removeProperty('height');
        textarea.style.height =
          textarea.scrollHeight < this.startHeight
            ? `${this.startHeight}px`
            : `${textarea.scrollHeight}px`;
      },

      onFocus() {
        this.$emit('on-focus');
      },

      onBlur() {
        this.$emit('on-blur');
      },

      onFocusout() {
        this.$emit('on-focusout');
      },
    },
  });
</script>

<style lang="scss" scoped>
  textarea {
    width: 100%;
    @include fontTextBtn;
    font-weight: 400;
    resize: none;
    border: none;
    padding: 12px 16px;
    border-radius: 4px;
    outline: none;
  }
</style>
